module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interlude"
  }, [_c('section', {
    staticClass: "interlude__about"
  }, [_c('h2', [_c('span', {
    staticClass: "icon"
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-about"
    }
  })])]), _vm._v("\n                About\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("Hi I'm Pascal, a front end developer from Berlin now based\n                    in South Germany near Lake Constance (Bodensee).\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "contact"
  }, [_c('li', [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-mail"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:email@artofmyself.com"
    }
  }, [_vm._v("email@artofmyself.com")])]), _vm._v(" "), _c('li', [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-gh"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/pascalaoms",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("@pascalaoms")])]), _vm._v(" "), _c('li', [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-fb"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://facebook.com/pascal.aoms",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("/pascal.aoms")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('h3', [_vm._v("Tools I work with")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/vue.svg'),
      "alt": "Vue"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://webpack.js.org",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/webpack.svg'),
      "alt": "Webpack"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://gulpjs.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/gulp.svg'),
      "alt": "Gulp"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://wordpress.org",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/wordpress.svg'),
      "alt": "WordPress"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://git-scm.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/git.svg'),
      "alt": "Git"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://sass-lang.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/sass.svg'),
      "alt": "Sass"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.adobe.com/de/products/experience-design.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/adobe-xd.svg'),
      "alt": "Adobe XD"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://es6-features.org",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require('Tools/es6.svg'),
      "alt": "ES2015 JavaScript"
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "interlude__articles"
  }, [_c('h2', [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 362.62 388.52"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FF9800",
      "d": "M156.58 239l-88.3 64.75c-10.59 7.06-18.84 11.77-29.43 11.77-21.19 0-38.85-18.84-38.85-40 0-17.69 14.13-30.64 27.08-36.52l103.6-44.74-103.6-45.92C13 142.46 0 129.51 0 111.85 0 90.66 18.84 73 40 73c10.6 0 17.66 3.53 28.25 11.77l88.3 64.75-11.74-104.78C141.28 20 157.76 0 181.31 0s40 18.84 36.5 43.56L206 149.52l88.3-64.75C304.93 76.53 313.17 73 323.77 73a39.2 39.2 0 0 1 38.85 38.85c0 18.84-12.95 30.61-27.08 36.5l-103.61 45.91L335.54 239c14.13 5.88 27.08 18.83 27.08 37.67 0 21.19-18.84 38.85-40 38.85-9.42 0-17.66-4.71-28.26-11.77L206 239l11.77 104.78c3.53 24.72-12.95 44.74-36.5 44.74s-40-18.84-36.5-43.56z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Articles on CSS Tricks")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    staticClass: "interlude__graphics"
  }, [_c('h2', [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#d9534f",
      "d": "M24.85 10.126C26.868 5.343 31.478 2 36.84 2c7.223 0 12.425 6.18 13.08 13.544 0 0 .352 1.828-.425 5.12-1.058 4.48-3.545 8.463-6.898 11.502L24.85 48 7.402 32.165c-3.353-3.038-5.84-7.02-6.898-11.503-.777-3.29-.424-5.12-.424-5.12C.734 8.18 5.936 2 13.16 2c5.362 0 9.672 3.343 11.69 8.126z"
    }
  })])]), _vm._v("\n            (He)artwork\n        ")]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentations list"
  }, [_c('h3', [_vm._v("Presentations I held")]), _vm._v(" "), _c('ul', {
    staticClass: "bullets"
  }, [_c('li', [_vm._v("Introduction to Sass, SMACSS, BEM and OOCSS")]), _vm._v(" "), _c('li', [_vm._v("Modular JavaScript w/ NPM, ES6, Webpack")]), _vm._v(" "), _c('li', [_vm._v("Liquid CSS — Percentages in Responsive Design")]), _vm._v(" "), _c('li', [_vm._v("Introduction to Git and Github")]), _vm._v(" "), _c('li', [_vm._v("What is Parallax and where to find it?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('h3', [_vm._v("Awards I won")]), _vm._v(" "), _c('ul', {
    staticClass: "bullets"
  }, [_c('li', [_c('h4', {
    staticClass: "organizer"
  }, [_vm._v("Parliament of Baden-Württemberg, South Germany")]), _vm._v(" "), _c('ul', {
    staticClass: "awards"
  }, [_c('li', [_c('strong', [_vm._v("1st Place (2016):")]), _vm._v(" educational purpose about robots and AI")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2nd Place (2017):")]), _vm._v(" educational purpose about data collection and safety")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "articles-list"
  }, [_c('li', {
    staticClass: "article"
  }, [_c('a', {
    attrs: {
      "href": "https://css-tricks.com/combine-webpack-gulp-4",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('h3', {
    staticClass: "article__title"
  }, [_vm._v("Combine Webpack with Gulp 4")]), _vm._v(" "), _c('time', {
    staticClass: "article__date",
    attrs: {
      "datetime": "2017-05-15"
    }
  }, [_vm._v("May 15, 2017")])])]), _vm._v(" "), _c('li', {
    staticClass: "article"
  }, [_c('a', {
    attrs: {
      "href": "https://css-tricks.com/polyfill-javascript-need",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('h3', {
    staticClass: "article__title"
  }, [_vm._v("Polyfill JavaScript Only When You Need To")]), _vm._v(" "), _c('time', {
    staticClass: "article__date",
    attrs: {
      "datetime": "2016-11-20"
    }
  }, [_vm._v("Nov 22, 2016")])])]), _vm._v(" "), _c('li', {
    staticClass: "article"
  }, [_c('a', {
    attrs: {
      "href": "https://css-tricks.com/hashes-in-wordpress-assets-with-enqueue",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('h3', {
    staticClass: "article__title"
  }, [_vm._v("Using Dynamic Hashes in File Names with WordPress’ Enqueue Function")]), _vm._v(" "), _c('time', {
    staticClass: "article__date",
    attrs: {
      "datetime": "2016-09-14"
    }
  }, [_vm._v("Sept 14, 2016")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro"
  }, [_vm._v("When I was 14 I started playing with graphic design.\n            It was merely a hobby since I didn't even use Photoshop but After Effects to create these visuals.\n        "), _c('br'), _vm._v("\n        Here is a little excerpt of the artworks:")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55902830"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/about-me.vue
// module id = 70
// module chunks = 0